
import { Component, Prop } from 'vue-property-decorator'
import Swiper, { SwiperOptions } from 'swiper'
import YoutubeVideo from '../components/youtube-video.vue'
import Mixin from '../helpers/mixin'

@Component({})
export default class ImageCarousel extends Mixin {
  @Prop() amountOfImages!: number

  swiperTop: Swiper | null = null

  thumbSwiper: Swiper | null = null

  showEnlargement = false

  swiperOptionsTop: SwiperOptions = {
    effect: 'fade',
    speed: 500,
    fadeEffect: { crossFade: true },
    navigation: {
      nextEl: '.swiper-button-next.top',
      prevEl: '.swiper-button-prev.top'
    },
    on: {
      slideChange: this.onSlideChange
    }
  }

  swiperOptionsThumbs: SwiperOptions = {
    slidesPerView: 1,
    freeMode: true,
    speed: 500,

    breakpoints: {
      600: {
        spaceBetween: 20,
        slidesPerView: 4
      }
    },
    on: {
      slideChange: this.onSlideChange
    }
  }

  get activeIndex(): number {
    return this.swiperTop ? this.swiperTop.activeIndex + 1 : 1
  }

  get showNavigation(): boolean {
    return !(this.thumbSwiper?.isBeginning && this.thumbSwiper?.isEnd)
  }

  openEnlargement(): void {
    if (this.showEnlargement || this.isTabletP || this.isPhone) return
    this.showEnlargement = true
    this.$store.commit('openContentOverlay')
  }

  closeEnlargement(): void {
    if (this.showEnlargement) {
      this.showEnlargement = false
      this.$store.commit('closeContentOverlay')
    }
  }

  onSlideChange(): void {
    const videos = this.$refs.youtubeVideo as YoutubeVideo[] | undefined
    videos?.forEach((video: YoutubeVideo) => {
      if(video.showVideo) video.resetVideo()
    })

    // slide thumb into view
    if (this.thumbSwiper && this.swiperTop) this.thumbSwiper.slideTo(this.swiperTop.activeIndex)
  }

  mounted() {
    // init swiper top with thumbs as controls
    if (this.amountOfImages > 1) {
      this.$nextTick(() => {
        const thumbSwiper = (this.$refs.swiperThumbs as any).$swiper as Swiper
        const swiperTop = (this.$refs.swiperTop as any).$swiper as Swiper
        this.swiperTop = swiperTop
        this.thumbSwiper = thumbSwiper
      })
    }
  }
}
